import React, { useMemo } from "react";
import { VsiBubbleFavs, VsiSmallText } from "../styled/App.styled";
import { Col, Row, Spinner } from "reactstrap";
import { useDataWithRoute } from "../utils/hooks";
import DonutChart from "../components/DonutChart";
import { useVsiAppContext } from "../stores/VsiApp";

export default function BUExecutiveOverview() {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("BUSINESS UNIT");

  const route = useMemo(() => `/api/v6/report/business_unit_executive_overview_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordsets: [dcData, classData, devData] }, { isLoading }] = useDataWithRoute(route);

  const { chartDataCenter, chartClassification, chartDeviceType } = useMemo(() => {
    return {
      chartDataCenter: dcData?.map?.(datum => ({
        name: datum["data_center"],
        y: datum["usable"]
      }) ?? []),
      chartClassification: classData?.map?.(datum => ({
        name: datum["classification"],
        y: datum["usable"]
      }) ?? []),
      chartDeviceType: devData?.map?.(datum => ({
        name: datum["device_type"],
        y: datum["usable"]
      }) ?? [])
    };
  }, [dcData, classData, devData]);

  return isLoading ? (
    <Spinner color={"success"}/>
  ) : (
    <VsiBubbleFavs>
      <Row>
        <Col key={`pie-grid-classification`} xs={12} lg={4}>
          <VsiSmallText>{"Storage Capacity (GiB) Distribution by Classification"}</VsiSmallText>

          <DonutChart data={chartClassification || []} title={""} height={350} innerSize={80}
                      disableLabels={true}
                      seriesName={"Usable"} />
        </Col>
        <Col key={`pie-grid-device_type`} xs={12} lg={4}>
          <VsiSmallText>{"Storage Capacity (GiB) Distribution by Device Type"}</VsiSmallText>

          <DonutChart data={chartDeviceType || []} title={""} height={350} innerSize={80}
                      disableLabels={true}
                      seriesName={"Usable"} />
        </Col>
        <Col key={`pie-grid-data_center`} xs={12} lg={4}>
          <VsiSmallText>{"Storage Capacity (GiB) Distribution by Data Center"}</VsiSmallText>
          <DonutChart data={chartDataCenter || []} title={""} height={350} innerSize={80}
                      disableLabels={true}
                      seriesName={"Usable"} />
        </Col>
      </Row>
    </VsiBubbleFavs>
  );
}